import { createApp } from "vue";
import StudentIdentifierConversion from "./components/StudentIdentifierConversion.vue";
import { getMountElements, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

export function initStudentIdentifierConversionApp(root = document) {
  for (const element of getMountElements(root, "[data-vue-student-identifier-conversion]")) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) continue;
    const app = createApp(StudentIdentifierConversion, {
      actionUrl: element.dataset.actionUrl,
      requestId: Number(element.dataset.requestId),
      schoolId: Number(element.dataset.schoolId),
      csrfToken: element.dataset.csrfToken,
    });
    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
  }
}
